import { AnyAction } from 'redux';
import { ErrorData } from '@synergy/api';

import {
    PRODUCT_DETAIL_FILES_DELETE,
    PRODUCT_DETAIL_FILES_ERROR,
    PRODUCT_DETAIL_FILES_RECEIVE,
    PRODUCT_DETAIL_FILES_RENAME,
    PRODUCT_DETAIL_FILES_SET_PREVIEW_IMAGE,
    PRODUCT_DETAIL_FILES_UPLOAD_PROGRESS,
    PRODUCT_DETAIL_FILES_UPLOAD_START,
    PRODUCT_DETAIL_FILES_UPLOAD_SUCCESS,
} from './product-detail-files-actions';
import { PRODUCT_DETAIL_RESET } from '../../store/product-detail-actions';
import { ProductFile, ProductImageFile, isImageFile } from '../../../../../../common/models/product-file';

export interface ProductDetailFilesReducerState {
    productId: number | null;
    files: (ProductFile | ProductImageFile)[];
    requestError?: ErrorData;
}

const initialFilesReducerState: ProductDetailFilesReducerState = {
    productId: null,
    files: [],
};

export const productDetailFilesReducer = (
    state: ProductDetailFilesReducerState = initialFilesReducerState,
    action: AnyAction
): ProductDetailFilesReducerState => {
    switch (action.type) {
        case PRODUCT_DETAIL_RESET: {
            return initialFilesReducerState;
        }

        case PRODUCT_DETAIL_FILES_RECEIVE: {
            return {
                ...state,
                files: [...action['productFiles'].images, ...action['productFiles'].documents],
                productId: action['productFiles'].id,
            };
        }

        case PRODUCT_DETAIL_FILES_ERROR: {
            return {
                ...state,
                requestError: action['errorData'],
            };
        }

        case PRODUCT_DETAIL_FILES_RENAME: {
            const index = state.files.findIndex(image => image.id === action['id']);
            if (index < 0) {
                return state;
            }

            const nextFiles = [...state.files];
            nextFiles[index] = { ...nextFiles[index], title: action['title'] };
            return { ...state, files: nextFiles };
        }

        case PRODUCT_DETAIL_FILES_SET_PREVIEW_IMAGE: {
            const nextFiles = state.files.map(file => {
                if (isImageFile(file) && (file.isPreviewImage || file.id === action['id'])) {
                    return { ...file, isPreviewImage: file.id === action['id'] };
                }
                return file;
            });
            return { ...state, files: nextFiles };
        }

        case PRODUCT_DETAIL_FILES_DELETE: {
            return {
                ...state,
                files: state.files.filter(file => file.id !== action['id']),
            };
        }

        case PRODUCT_DETAIL_FILES_UPLOAD_START: {
            return {
                ...state,
                files: [...state.files, action['file']],
            };
        }

        case PRODUCT_DETAIL_FILES_UPLOAD_PROGRESS: {
            const index = state.files.findIndex(
                file => file.title === action['file'].title && file.size === action['file'].size
            );
            if (index < 0) {
                return state;
            }

            const nextFiles = [...state.files];
            nextFiles[index] = { ...nextFiles[index], uploadProgress: action['progress'] };
            return {
                ...state,
                files: nextFiles,
            };
        }

        case PRODUCT_DETAIL_FILES_UPLOAD_SUCCESS: {
            const index = state.files.findIndex(
                file => file.title === action['file'].title && file.size === action['file'].size
            );
            if (index < 0) {
                return state;
            }

            const nextFiles = [...state.files];
            nextFiles[index] = action['file'];
            return {
                ...state,
                files: nextFiles,
            };
        }

        default: {
            return state;
        }
    }
};
